import React from "react";
import { ExternalLink, Sparkles } from "lucide-react";

// Add new sponsors here. Empty `logo` falls back to a styled text card.
const sponsors = [
  {
    key: "714tickets",
    name: "714 Tickets",
    url: "https://www.714tickets.com/",
    logo: "https://www.714tickets.com/logo192.png",
    tagline: "Get tickets to every Angels & Ducks home game",
    code: "HITI",
    discount: "10% OFF + extra 5% credit toward your next purchase",
  },
  {
    key: "in2wings",
    name: "In2Wings",
    url: "https://www.in2wings.com/",
    logo: "https://www.google.com/s2/favicons?sz=128&domain=in2wings.com",
    tagline: "OC's go-to wing spot — postgame fuel",
    code: "HITI",
    discount: "Mention HITI for a fan discount",
  },
  {
    key: "noblealeworks",
    name: "Noble Ale Works",
    url: "https://www.noblealeworks.com/",
    logo: "https://www.google.com/s2/favicons?sz=128&domain=noblealeworks.com",
    tagline: "Anaheim's hometown brewery · Pour one out for the Halos",
    code: "HITI",
    discount: "Mention HITI at the taproom for a fan discount",
  },
  // Add more sponsors here — same shape — and they'll auto-render
];

export default function SponsorsBar() {
  if (!sponsors.length) return null;

  return (
    <section
      className="relative bg-halo-cream border-y-2 border-halo-navy py-8 px-6 md:px-12 lg:px-16"
      data-testid="sponsors-bar"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-center gap-3 mb-6">
          <Sparkles className="w-4 h-4 text-halo-red" strokeWidth={2.5} />
          <span className="font-sports uppercase tracking-[0.35em] text-[11px] text-halo-navy/70">
            Official Sponsors · Exclusive HITI Discounts
          </span>
          <Sparkles className="w-4 h-4 text-halo-red" strokeWidth={2.5} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {sponsors.map((s) => (
            <a
              key={s.key}
              href={s.url}
              target="_blank"
              rel="noreferrer noopener"
              data-testid={`sponsor-${s.key}`}
              className="group block bg-white border-2 border-halo-navy hover:border-halo-red transition-colors overflow-hidden"
            >
              <div className="flex items-stretch">
                <div className="w-24 sm:w-28 bg-halo-navy flex items-center justify-center p-3 shrink-0">
                  {s.logo ? (
                    <img
                      src={s.logo}
                      alt={s.name}
                      className="w-full h-full object-contain max-h-20"
                      onError={(e) => { e.target.style.display = "none"; }}
                    />
                  ) : (
                    <span className="font-sports uppercase tracking-tight text-halo-cream text-lg text-center leading-none">
                      {s.name}
                    </span>
                  )}
                </div>
                <div className="flex-1 p-4 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="font-sports uppercase tracking-tight text-base text-halo-navy group-hover:text-halo-red transition-colors">
                        {s.name}
                      </h3>
                      <ExternalLink className="w-3.5 h-3.5 text-halo-navy/40 group-hover:text-halo-red" strokeWidth={2.5} />
                    </div>
                    {s.tagline && (
                      <p className="font-body text-[11px] text-halo-navy/60 mt-1 leading-snug line-clamp-2">{s.tagline}</p>
                    )}
                  </div>
                  {s.code && (
                    <div className="mt-2 flex items-center gap-2 flex-wrap">
                      <span className="inline-flex items-center gap-1 bg-halo-red text-white font-sports uppercase tracking-widest text-[10px] px-2 py-1">
                        Code <span className="text-yellow-200">{s.code}</span>
                      </span>
                      <span className="font-body text-[11px] text-halo-navy/80 leading-tight">
                        {s.discount}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </a>
          ))}
        </div>

        <p className="text-center font-body text-[11px] text-halo-navy/50 mt-5">
          Mention <span className="font-sports tracking-widest text-halo-red">HITI</span> at checkout to unlock the discount.
        </p>
      </div>
    </section>
  );
}
